import { RecoveryModel } from "../../../models/auth/RecoveryModel";
import { inject, injectable } from "inversify";
import IAlertService from "../../alert/IAlertService";
import { DiTokens } from "../../diTokens";
import IErrorService from "../../error/IErrorService";
import AnonymousOperationService from "../../operations/AnonymousOperationService";
import { ConfigStore } from "../../../store/modules/config";
import storeAccessor from "../../../store/storeAccessor";
import { getModule } from "vuex-module-decorators";
import { AuthStore } from "../../../store/modules/auth";
import i18n from "@/i18n"

/**Сервис восстановления доступа*/
@injectable()
export default class RecoveryService extends AnonymousOperationService {
  constructor(
    @inject(DiTokens.AlertService) public alertService: IAlertService,
    @inject(DiTokens.ErrorService) public errorService: IErrorService
  ) {
    super(alertService, errorService);
  }

  /**
   * Инициализация операции
   * @param initData Данные для инициализации
   * */
  public async init(): Promise<RecoveryModel> {
    const operationData = new RecoveryModel();
    operationData.PasswordRecRespondentCode =
      this.configStore.apiData.OperationCodeOfRecoveryPassword || "RecoveryPassword";
    operationData.LoginRecRespondentCode =
      this.configStore.apiData.OperationCodeOfRecoveryLogin || "RecoveryLogin";
    return operationData;
  }

  public async nextStep(model: RecoveryModel): Promise<RecoveryModel> {
    return (await super.nextStep(model)) as RecoveryModel;
  }

  public async prepare(actionModel: RecoveryModel): Promise<RecoveryModel> {
    try {
      actionModel = await super.prepare(actionModel) as RecoveryModel;
    } catch (e) {
      actionModel.ActionStateText = e.message;
      await this.errorService.errorHandler(e, false, false, "");
    }
    return actionModel;
  }


  public async execute(actionModel: RecoveryModel): Promise<RecoveryModel> {
    try {
      actionModel = await super.execute(actionModel) as RecoveryModel;
    } catch (e) {
      actionModel.ActionStateText = e.message;
      await this.errorService.errorHandler(e, false, false, "");
    }
    return actionModel;
  }

  /**
* Действия после проведения операции
* @param args
*/
  public async afterExecute(model: RecoveryModel): Promise<any> {
    this.authStore.setMsg(model.SuccessMessage);
    if(model.RecoveryMode == model.PasswordMode)
      this.authStore.setLogin(model.Login);
  }

  /**Стор настроек */
  get configStore(): ConfigStore {
    return getModule(ConfigStore, storeAccessor.store);
  }

  /**Стор настроек */
  get authStore(): AuthStore {
    return getModule(AuthStore, storeAccessor.store);
  }
}
